import React from "react";

const Imprint = (props) => (
    <div className="container">
        <h2>Impressum</h2>
        <p><strong>Stiebing Immobilien und Baumanagement GmbH</strong></p>
        <div className="row">
            <div className="col-sm-2"><p>Anschrift</p></div>
            <div className="col-sm-10">
                <p>Fanny-Hensel-Straße 2<br/>
                    D 91056 Erlangen</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Anschrift</p></div>
            <div className="col-sm-10">
                <p>Fanny-Hensel-Straße 2<br/>D 91056 Erlangen</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Telefon</p></div>
            <div className="col-sm-10">
                <p>091 31 68 79 760</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Telefax</p></div>
            <div className="col-sm-10">
                <p>091 31 68 79 754</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>eMail</p></div>
            <div className="col-sm-10">
                <p><a href="mailto:willkommen@sib-immobilien.de">willkommen@sib-immobilien.de</a></p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Home</p></div>
            <div className="col-sm-10">
                <p><a href="http://www.sib-immobilien.de">www.sib-immobilien.de</a></p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Geschäftsführer</p></div>
            <div className="col-sm-10">
                <p>Frank Stiebing</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Handelsregister</p></div>
            <div className="col-sm-10">
                <p>AG Fürth/Bayern HR B 9461</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Gerichtsstand</p></div>
            <div className="col-sm-10">
                <p>Erlangen, DE</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Steuer-Nr.</p></div>
            <div className="col-sm-10">
                <p>216/139/40054</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Aufsichtsbehörden<br/>Gewerbeerlaubnis</p></div>
            <div className="col-sm-10">
                <p>Ordnungs- und Gewerbeamt<br/>Stadt Erlangen 91051, Rathausplatz 1<br/>Erlaubnis nach § 34c
                    Gewerbeordnung</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Geschäftsführer</p></div>
            <div className="col-sm-10">
                <p>IHK Nürnberg für Mittelfranken</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Versicherungs-<br/>vermittlerregister<br/>Versicherungs-<br/>makler nach</p>
            </div>
            <div className="col-sm-10">
                <p>IHK für München und Oberbayern, Max-Joseph-Straße 2, 80333 München<br/><a
                    href="www.ihk-muenchen.de">www.ihk-muenchen.de</a><br/>Eintragung gem. § 11a Gewerbeordnung<br/>Erlaubnis
                    nach § 34d Abs. 1 Gewerbeordnung<br/>Registrierungs-Nr. D-7MYY-TIT9S-23</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Finanzanlagen-<br/>vermittlerregister</p></div>
            <div className="col-sm-10">
                <p>IHK für München und Oberbayern, Max-Joseph-Straße 2, 80333 München<br/>Erlaubnis nach § 34 f Abs. 1
                    S. 1 GewO<br/>&nbsp;&nbsp;1) Investmentanteile<br/>&nbsp;&nbsp;2) geschlossene Fonds als
                    KG<br/>&nbsp;&nbsp;3) sonstige Vermögensanlagen<br/>Registrierungs-Nr. D-F-155-S2AU-12</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-2"><p>Vermögen-<br/>Schadenhaftpflicht</p></div>
            <div className="col-sm-10">
                <p>ALLIANZ Versicherung AG</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-12">
                <p><strong>Allgemeine Hinweise</strong></p>
                <p>Verantwortlich für die Inhalte der Webseite ist die SIB GmbH, Fanny-Hensel-Straße 2, D91056 Erlangen,
                    email: <a href="willkommen@sib-immobilien.de">willkommen@sib-immobilien.de</a>.</p>
                <p>Das Landgericht Hamburg hat mit Urteil vom 12. Mai 1998 entschieden, dass man durch die Anbringung
                    bzw. Ausbringung von Links, die Inhalte der gelinkten Seite ggf. mit zu verantworten hat. Dies kann
                    - so das Landgericht Hamburg - nur dadurch verhindert werden, dass man sich ausdrücklich von den
                    Inhalten der gelinkten Seite, bzw. des gesamten Webs distanziert.</p>
                <p>Für alle diese Links gilt:</p>
                <p>„Wir möchten ausdrücklich betonen, dass wir keinerlei Einfluss auf die Gestaltung und Inhalte der
                    gelinkten Webseiten haben. Daher distanzieren wir uns hiermit ausdrücklich von allen Inhalten aller
                    gelinkten Webseiten auf unserer gesamten Webseite inkl. aller Unterseiten und deren Unterlinks oder
                    anderen Weiterleitungsmechanismen. Diese Erklärung gilt für alle auf unserer Homepage angebrachten
                    Links und für alle Inhalte der Seiten, zu denen Links, Banner oder sonstige Verknüpfungen
                    führen.“</p>
                <p>Inhalt und Struktur der SIB GmbH-Webseiten sind urheberrechtlich geschützt. Die Vervielfältigung von
                    Informationen oder Daten, insbesondere die Verwendung von Texten, Textteilen oder Bildmaterial,
                    bedarf der vorherigen schriftlichen Zustimmung der SIB GmbH.</p>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-12">
            <p><strong>Rechtshinweise</strong></p>
                <p>Diese Webseite bietet nur allgemeine Informationen über Versicherungen, Finanzierungen, Immobilien
                    und
                    Investments. Diese Informationen stellen keine Beratung dar. Eine Anlage in einen Fonds oder eine
                    Immobilie ist möglicherweise nicht für alle Investoren geeignet, und wenn Sie Zweifel hinsichtlich
                    einer
                    Information auf dieser Webseite haben, empfehlen wir Ihnen, vor jeder Finanzierung, Versicherungs-,
                    Anlage- oder sonstigen Finanzentscheidung mit uns zu sprechen.</p>
                <p>Auch wenn die Informationen auf dieser Webseite mit größter Sorgfalt zusammengestellt wurden, so
                    können
                    hieraus dennoch keinerlei Rechte hergeleitet werden. Diese Webseite hat allein rein informativen
                    Charakter und fordert Interessenten auf, zwecks Erhalt weiterer Einzelheiten Kontakt aufzunehmen.
                    Die
                    SIB GmbH übernimmt keinerlei Haftung für den Inhalt dieser Webseite, für deren Form und
                    Zusammenstellung
                    und für etwaige erzeugte Eindrücke.</p>
                <p>In der Vergangenheit erzielte Renditen bieten keinerlei Gewähr für deren Bestand in der Zukunft. Die
                    SIB
                    GmbH übernimmt keinerlei Garantien, sofern nicht ausdrücklich anders schriftlich bestätigt. Die
                    Informationen auf dieser Webseite lassen keine vorvertraglichen Pflichten und damit keine
                    vorvertragliche Haftung entstehen, da sie rein informativen und nicht verpflichtenden Charakter
                    haben.</p>
                <p>Wir übernehmen keine Haftung für Fehler bei der Datenübertragung wie z.B. Datenverlust,
                    Datenbeschädigung
                    oder Datenveränderung jedweder Art und daraus resultierenden direkten und indirekten Schäden und
                    Folgeschäden bei der Verwendung dieser Daten für die angebotenen Dienstleistungen</p>
                <p>Mitteilungen, die Sie uns per eMail senden, sind möglicherweise nicht sicher. Wir empfehlen Ihnen,
                    keine
                    vertraulichen Informationen per eMail an uns zu senden. Wenn Sie uns per eMail vertrauliche
                    Informationen senden, geschieht dies auf Ihre eigene Gefahr und Sie sind sich darüber im Klaren,
                    dass
                    sich Dritte unter Umständen Zugang zu diesen Informationen verschaffen können.</p>
                <p>Die Webseite kann Beratungsdienste oder Angaben von Dritten oder Links zu diesen enthalten. Wir
                    übernehmen keine Verantwortung für die Richtigkeit, Vollständigkeit, Aktualität oder Tauglichkeit
                    solcher Informationen, die wir nicht überprüfen und aktualisieren. Wir weisen Sie darauf hin, dass
                    die
                    Verwendung dieser Informationen auf Ihre eigene Gefahr erfolgt.</p>
                <p>Sollten einzelne der vorgenannten Hinweise unwirksam sein oder werden, so bleibt die Wirksamkeit der
                    übrigen Bestimmungen hiervon unberührt. An die Stelle der unwirksamen Bestimmung tritt eine solche,
                    die
                    bei Kenntnis der Unwirksamkeit gewählt worden wäre.</p>
            </div>
        </div>
    </div>
)

export default Imprint;



// WEBPACK FOOTER //
// ./src/imprint/imprint.js